import { createServerRunner } from "@aws-amplify/adapter-nextjs";
import { ResourcesConfig } from "aws-amplify";

export const config: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.NEXT_PUBLIC_USER_POOL_ID || "",
      userPoolClientId: process.env.NEXT_PUBLIC_USER_POOL_CLIENT_ID || "",
      userAttributes: {
        email: {
          required: true,
        },
        given_name: {
          required: true,
        },
        family_name: {
          required: true,
        },
      },
    },
  },
};

export const { runWithAmplifyServerContext } = createServerRunner({
  config,
});

export const errorIsUserIsNotAuthenticated = (error: any) => {
  return error && error.name && error.name === "UserUnAuthenticatedException";
};

export class UserIsNotAuthenticatedError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "UserUnAuthenticatedException";
  }
}
